module.exports = __webpack_public_path__ + "static/media/credit-card-back.93f6a24b.png";